/**
 * @module explore/components/explore
 */
import React, { PropTypes } from 'react';

/**
 * Wrapping component for explore pages
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const Explore = (props) => (
  <div className="l-content" id="content">
    { props.children }
  </div>
);

/**
 * PropTypes.
 *
 * @property {node} children - child nodes to render
 */
Explore.propTypes = {
  children: PropTypes.node,
};

export default Explore;



// WEBPACK FOOTER //
// ./explore/components/explore.jsx